<script setup>
  const props = defineProps({
    enableSidePanel: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: false,
    },
  });

  import Sidebar from "~/components/Sidebar.vue";

  const astronautPage = ref(null)


  onMounted(async () => {
    await document.fonts.ready
  });


  onBeforeUnmount(() => {
  });
</script>

<template>
  <section>
    <div ref="astronautPage" :class="{'modular-main-container': enableSidePanel}">

      <Sidebar v-if="enableSidePanel" :data="data"/>

      <div :class="{'modular-main-content': enableSidePanel}">
        <slot />
      </div>
    </div>
  </section>
</template>